import { connect } from 'react-redux';
import TrendingModal from './TrendingModal';

const mapStateToProps = ({
  intl: { locale },
  system: { isMobile, siteName },
  content: { searchBox }

}) => ({
  locale,
  isMobile,
  siteName,
  ...searchBox
});

export default connect(mapStateToProps)(TrendingModal);
